import { ImageCollectionItemT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { CurrentImageT } from '../OV-subcomponents';
import './ImageThumbnails.scss';

type ImageThumbnailsProps={
    currentImage?: CurrentImageT ;
    images?: CurrentImageT [];
    isModal?: boolean;
    onClick?: (index: number) => void;
};

const ImageThumbnails: React.FC<ImageThumbnailsProps> = ({ children, isModal = false, currentImage, images, onClick }): ReactElement => {
    return (
        <div className={`bv-objectview-thumbnails  ${isModal ? ' bv-objectview-thumbnails--modal' : ''}`}>
            <div className='bv-objectview-thumbnails-wrapper'>
                {images?.map(({ image }, index) => {
                    const props = {
                        className:`bv-objectview-thumbnail${ (currentImage?.image.id === image.id) ? ' bv-objectview-thumbnail--current' : ''}`,
                        key: image.id
                    };

                    return <div {...props} onClick ={(): void => onClick && onClick(index)}><img alt={image.filename} src={(image as ImageCollectionItemT).url?.small} /></div>;
                })}
            </div>
        </div>
    );
};


export default ImageThumbnails;